// @flow
import { deleteCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  DELETE_ORDER: `${environment.apiUrl}/purchase/:id`,
});

export const deleteOrderApi = deleteCreator(fetch, endpoints.DELETE_ORDER);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/unconfirmed-payment/api.js